<app-breadcrumb *ngIf="!partnerFacilityObject" [master]="'Struktura sieci'" [parentName]="'Placówki'"
                [name]="'Dodaj'"></app-breadcrumb>
<div class="facility-add" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!addressForm.valid || !facilityTypeControl.valid || !facilityDobryAgentNameControl.valid"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <app-address-form [addressForm]="addressForm" [title]="'Adres placówki'"></app-address-form>
      <mat-card fxLayout="column" fxFlex="100" fxLayoutGap="15px"
                *ngIf=" (userPermissions | async).dobry_agent.write && (userApplicationPermission | async).dobryagent.active
        && dobryAgentFacility">

        <h3>Wizytówka DobryAgent.pl - powiązanie</h3>

        <ng-container *ngIf="!checkingDobryAgentLink; else checkingDobryAgentLinkTpl">
          <ng-container *ngIf="linkedDobryAgentFacility; else dobryAgentNotLinked">
            <app-detail
              header="Powiązana placówka DobryAgent.pl"
              [value]="linkedDobryAgentFacility.name">
            </app-detail>
          </ng-container>
          <ng-template #dobryAgentNotLinked>
            <div fxLayout="column" fxLayoutGap="15px">
              <mat-slide-toggle
                fxFlex="100"
                [formControl]="addFacilityDobryAgentControl">
                Dodaj placówkę DobryAgent.pl
              </mat-slide-toggle>

              <ng-container *ngIf="addFacilityDobryAgentControl.value">
                <div fxLayout="row" fxLayoutGap="15px">
                  <mat-form-field fxFlex="50">
                    <mat-label>Nazwa placówki DobryAgent.pl</mat-label>
                    <input
                      matInput
                      [formControl]="facilityDobryAgentNameControl"
                      placeholder="Np. Ubezpieczenia Jan Kowalski">

                    <mat-error *ngIf="facilityDobryAgentNameControl.hasError('required')">
                      Nazwa placówki jest wymagana
                    </mat-error>
                  </mat-form-field>

                  <app-city-dobry-agent-select
                    fxFlex="50"
                    label="Miasto"
                    [formControl]="facilityDobryAgentCityControl">
                  </app-city-dobry-agent-select>
                </div>

                <div fxFlex="100" class="editor-field">
                  <label class="editor-field__label">Opis</label>
                  <angular-editor
                    [formControl]="facilityDobryAgentDescriptionControl"
                    [config]="editorConfig">
                  </angular-editor>
                </div>
              </ng-container>
            </div>
          </ng-template>
        </ng-container>

        <ng-template #checkingDobryAgentLinkTpl>
          <div class="text-muted">
            Sprawdzanie powiązania z DobryAgent.pl...
          </div>
        </ng-template>
        <div fxLayout="row"
             *ngIf="(userPermissions | async).dobry_agent.admin_root && !addFacilityDobryAgentControl.value">
          <div fxFlex="100">
            <app-facility-dobry-agent-select
              label="Placówka DobryAgent - widok tylko dla Adminstratora"
              [control]="facilityDobryAgentControl"
              [multiple]="false"
              [required]="false"
              [returnKey]="false">
            </app-facility-dobry-agent-select>
          </div>
        </div>
      </mat-card>
      <mat-card>
        <div fxLayout="row">
          <h3>Uwagi</h3>
        </div>

        <div fxLayout="row">
          <mat-form-field fxFlex="100">
            <mat-label>Uwagi</mat-label>
            <textarea [formControl]="noteControl" matInput placeholder="Uwagi"></textarea>
          </mat-form-field>
        </div>
      </mat-card>
    </div>

    <div fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px" fxLayout="column">
      <mat-card>
        <div fxLayout="row">
          <h3>Relacje</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <mat-form-field fxFlex="100">
              <mat-label>Numer terminala</mat-label>
              <input matInput placeholder="Numer terminala" [formControl]="terminalNumberControl" [required]="false">
              <mat-error
                *ngIf="partnerFacilityForm.get('terminalNumber').hasError('backendError')">{{ errors.terminalNumber }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <ng-container *ngFor="let partnerControl of partnersFormArray.controls; let i = index">
          <div fxLayout="row" fxLayoutGap="15px">
            <div fxLayout="row" fxFlex="50">
              <div fxFlex="100">
                <app-dict-partners [filterProfit]="profitFacility" [label]="'Partner'" [control]="getPartnerControl(i)"
                                   class="facility-dialog-partner" [required]="true"></app-dict-partners>
              </div>
            </div>

            <div fxLayout="row" fxFlex="50">
              <div fxFlex="70" class="partner-list-buttons">
                <button [disabled]="!partnerControl.value" [matMenuTriggerFor]="copyMenu" mat-stroked-button
                        color="accent">
                  <mat-icon>content_copy</mat-icon>
                  <span> Kopiuj adres</span>
                </button>
                <mat-menu #copyMenu="matMenu">
                  <button mat-menu-item (click)="copyHeadquartersAddress(i)">Siedziby</button>
                  <button mat-menu-item (click)="copyCommunicationAddress(i)">Korespondencyjny</button>
                </mat-menu>
              </div>
              <span fxFlex></span>
              <div fxFlex class="partner-list-buttons" *ngIf="i > 0">
                <button (click)="removePartner(i)" mat-icon-button color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>

          </div>
        </ng-container>

        <div fxLayout="row">
          <mat-error
            *ngIf="partnerFacilityForm.get('partners').hasError('backendError')">{{ partnerFacilityForm.get('partners').getError('backendError') }}
          </mat-error>
        </div>

        <div fxLayout="row" *ngIf="profitFacility || dobryAgentFacility">
          <span fxFlex></span>
          <button (click)="addPartner()" mat-stroked-button color="primary">
            <mat-icon>add_box</mat-icon>
            <span> Dodaj</span>
          </button>
        </div>

      </mat-card>

      <mat-card *ngIf="profitFacility">
        <div fxLayout="row">
          <h3>Profitowi</h3>
        </div>

        <app-dict-ofwcas label="Dyrektor struktury" [filterProfit]="true" [control]="structureDirectorControl"
                         class="facility-dialog-partner" [required]="false"></app-dict-ofwcas>

        <app-dict-ofwcas label="Wicedyrektor" [filterProfit]="true" [control]="assistantDirectorControl"
                         class="facility-dialog-partner" [required]="false"></app-dict-ofwcas>

        <app-dict-ofwcas label="Dyrektor reigonalny" [filterProfit]="true" [control]="regionalControl"
                         class="facility-dialog-partner" [required]="false"></app-dict-ofwcas>
      </mat-card>

      <mat-card *ngIf="profitTag">
        <div fxLayout="row">
          <h3>Typ placówki</h3>
        </div>

        <div fxLayout="row">
          <div fxFlex="100">
            <app-dict [label]="'Typ placówki'" [dictType]="'facility_type' " [control]="facilityTypeControl"
                      [required]="true"></app-dict>
          </div>
        </div>
      </mat-card>

      <mat-card *ngIf="profitPartner">
        <div fxLayout="row">
          <h3>Typ placówki</h3>
        </div>

        <div fxLayout="row">
          <div fxFlex="100">
            <app-dict [label]="'Typ placówki'"
                      [onlyKeys]="PARTNER_TYPES"
                      [dictType]="'facility_type' "
                      [control]="facilityTypeControl"
                      [required]="true"></app-dict>
          </div>
        </div>
      </mat-card>


    </div>

  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!addressForm.valid || !facilityTypeControl.valid || !facilityDobryAgentNameControl.valid"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span></button>
  </div>
</div>
